import { CART } from './constants';

const getLocalStorage = (initState) => {
  const cart = JSON.parse(localStorage.getItem(CART)) || [];

  const localData = {
    cart
  };

  return localData ? { ...initState, ...localData } : initState;
};
export default getLocalStorage;
